<template>
  <div class="lawyer" v-wechat-title="$route.meta.title">
    <Header/>
    <BannerBg/>
    <div class="home_main_box" id="home_main_box">
      <div class="site_width">
        <div class="Practices_title pc_only_i">
          <h1>团队成员</h1>
          <span>Professionals</span></div>
      </div>
      <div class="site_width">
        <div class="word_search pc_only_i">
          <div class="width10">
            <div class="width4">
              <div class="padding_right15">
                <input placeholder="按姓名搜索" v-model="pageParams.userName" type="text" class="inputselect" value="">
              </div>
            </div>
            <div class="width4">
              <div class="padding_right15">
                <input placeholder="按职位类别搜索" v-model="pageParams.qualification" type="text" class="inputselect" value="">
                <!-- <select v-model="pageParams.qualification" class="inputselect">
                  <option value=null>按职位类别搜索</option>
                  <option v-for="item in qcOptions" :key="item.id" :value="item.id">{{ item.label }}</option>
                </select> -->
              </div>
            </div>
            <div class="width4">
              <div class="padding_right15">
                <input placeholder="按业务领域搜索" v-model="pageParams.field" type="text" class="inputselect" value="">
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="width2">
            <input name="Submit4" class="search_btn_show input100" type="button" value="搜索工作人员" @click="onSubmit()"></div>
          <div class="clear"></div>
        </div>
        <div class="lawyer_show_box">
          <ul>
            <li v-for="item in tableData" :key="item.id">
              <a @click="contentTo(item.id)">
                <div class="width2 lawyer_pic">
                  <img :src=item.pic class="pc_only_i">
                  <img :src=item.pic class="phone_only_i"></div>
                <div class="width10">
                  <div class="lawyer_txt">
                    <div class="width4">
                      <h3>{{ item.userName }}</h3>
                    </div>
                    <div class="width4">
                      <!-- <p class="lawyer_position">- {{ changeQcValue(item.qualification) }}</p> -->
                      <p class="lawyer_position">- {{ item.qualification }}</p>
                    </div>
                    <div class="width4">
                      <p>
                        <span v-for="ite in item.field" :key="ite.key" >
                          - {{ ite.value }}
                        </span>
                      </p>
                    </div>
                    <div class="clear"></div>
                  </div>
                </div>
                <div class="clear"></div>
              </a>
            </li>
          </ul>
          <div class="pagination_box">
            <el-pagination
              class="formPagination"
              background
              :pager-count="5"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageParams.pageNo"
              :page-size="pageParams.pageSize"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  export default {
    name: "lawyer",
    data() {
      return {
        tableData: [],
        pageParams: {
          userName: null,
          qualification: null,
          field: null,
          state: 0,
          pageNo: 1,
          pageSize: 10
        },
        total: 0,
        qcOptions: [
          {id: 0, label: '高级合伙人'},
          {id: 1, label: '合伙人'},
          {id: 2, label: '顾问'},
          {id: 3, label: '资深律师'},
          {id: 4, label: '律师'},
          {id: 5, label: '律师助理'}
        ]
      }
    },
    mounted() {
      this.getPageList()
    },
    methods: {
      getPageList() {
        this.isLoading = true
        this.$axios.get(this.$apiUrl.LAWYER_PAGE_API_URL, 'Json', this.pageParams)
        .then(res => {
          this.isLoading = false
          if (res.data.code == 200) {
            this.total = res.data.data.total
            res.data.data.list.find((item)=>{
              item.achievement = JSON.parse(item.achievement)
              item.field = JSON.parse(item.field)
            })
            this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(err => {
            this.isLoading = false
            this.$message.error("服务器出现差错")
        })
      },
      onSubmit() {
        this.getPageList()
      },
      handleCurrentChange(pageNo) {
        this.pageParams.pageNo = pageNo
        this.getPageList()
      },
      handleSizeChange(pageSize) {
        this.pageParams.pageSize = pageSize
        this.getPageList()
      },
      changeQcValue(val) {
        if (val == undefined) {
            return ''
        }
        let obj = {}
        obj = this.qcOptions.find((item)=>{
          return item.id == val
        })
        return obj.label
      },
      contentTo(id) {
        this.$router.push('/lawyerDetail/' + id)
      }
    }
  }
</script>

<style scoped lang="less">
  .el-pagination {
    margin-top: 15px;
    text-align: center; 
  }
</style>